// extracted by mini-css-extract-plugin
export default {"acceptLicence":"acceptLicence-KlM9"};